@if (!hasError && src) {
  <img [src]="src" style="max-width: 64px; max-height: 64px;" [alt]="alt" (error)="onImageError()">
}
@if (hasError || !src) {
  <div class="monogram">?</div>
}
